module.exports = __webpack_public_path__ + "img/autre-site.97595631.svg";